import { useUserRewardsMe } from '@/api/user-rewards';
import { RewardId } from '@/enums/reward-id';
import { ErrorCard } from '@starsoft/common/components';
import LuckySpinHeaderOptions from './ButtonOptions';
import styles from './styles.module.scss';

export default function LuckySpinHeader(): JSX.Element {
  const { isLoading, error, refetch } = useUserRewardsMe({
    rewardId: RewardId.LuckyWheel,
    refetchOnMount: 'always',
  });

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <div className={styles.container}>
      <LuckySpinHeaderOptions isLoading={isLoading} />
    </div>
  );
}
